import { SelectOption } from 'basics/options/options.types';
import { SpendCategory } from 'modules/maya/basics/enums/maya.enums';

const SpendCategoryOptions: SelectOption[] = [
  { id: SpendCategory.SpendCategory1, label: 'SpendCategory 1' },
  { id: SpendCategory.SpendCategory2, label: 'SpendCategory 2' },
];

export default SpendCategoryOptions;
